import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { RESERVATION_LIST_REPORT_ENDPOINT } from '../endpoint';
import { ReservationListReportRequestModel } from '../models/ReservationListReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: ReservationListReportRequestModel): Promise<void> => {
    return await axios
      .get(`${RESERVATION_LIST_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'reservation-list-report',
        });
      });
  };
